export const FORM_DEFAULTS = {
  maxTitleLength: 100,
  maxDescriptionLength: 500,
  descriptionRows: 4,
} as const;

export const INSIGHT_SOURCES = {
  MONITORING: 'monitoring',
  REPORT: 'report',
} as const;

export const INSIGHT_MODAL_CLOSE = 'insight-modal-close';
export const INSIGHT_MODAL_NAVIGATE_REQUEST = 'insight-modal-request-navigate';

export interface InsightModalMetadata {
  title?: string;
  description?: string;
  isReport?: boolean;
  criticalElement?: string;
  criticalElementId?: string | number;
  relatedGoals?: string[];
  relatedGoalIds?: Array<string | number>;
  source?: string;
  summary?: string;
  name?: string;
  clientId?: string | number;
  reportActivePage?: unknown;
  reportFilters?: Array<{ column: string; values?: string[] }>;
  reportId?: string | number;
}
